import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axiosConfig';

const RefundPolicy = () => {
  const [refund, setRefund] = useState('');

  useEffect(() => {
    const fetchRefund = async () => {
      try {
        const response = await axiosInstance.get("master/getrefund");

        if (response.data && response.data.length > 0) {
          setRefund(response.data[0].name);
        }
      } catch (error) {
        console.error("Error fetching refund policy:", error);
      }
    };

    fetchRefund();
  }, []);

  return (
    <section className="py-5" style={{ background: "#f5f7fa" }}>
      <div className="container">

        {/* HEADER */}
        <div className="text-center mb-4">
          <h2 className="fw-bold" style={{ color: "#222" }}>
            Refund & Cancellation Policy
          </h2>
          <p className="text-muted">
            Find details about refunds, cancellations, and return processes.
          </p>
        </div>

        {/* CARD */}
        <div className="card shadow-sm border-0 rounded-4">
          <div className="card-body p-4">

            {/* SCROLLABLE CONTENT */}
            <div
              className="overflow-auto"
              style={{
                maxHeight: "500px",
                paddingRight: "5px"
              }}
              dangerouslySetInnerHTML={{ __html: refund }}
            />

          </div>
        </div>

      </div>
    </section>
  );
};

export default RefundPolicy;
